"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionedIdentifier = exports.IncludeDef = exports.UsingDef = void 0;
const expression_1 = require("./expression");
class UsingDef extends expression_1.UnimplementedExpression {
}
exports.UsingDef = UsingDef;
class IncludeDef extends expression_1.UnimplementedExpression {
}
exports.IncludeDef = IncludeDef;
class VersionedIdentifier extends expression_1.UnimplementedExpression {
}
exports.VersionedIdentifier = VersionedIdentifier;
//# sourceMappingURL=declaration.js.map